import { twMerge } from 'tailwind-merge';

import {
  type ExternalUrlValidationStatus,
  getExternalUrlValidationMessageClassName,
} from '../hooks/useExternalUrlValidation';

interface Props {
  className?: string;
  hasLocalError?: boolean;
  message: string;
  status: ExternalUrlValidationStatus;
}

function isBusy(status: ExternalUrlValidationStatus) {
  return status === 'checking' || status === 'pending';
}

export function UrlValidationStatus(props: Props) {
  if (!props.message) {
    return null;
  }

  return (
    <div
      aria-live="polite"
      className={twMerge(
        'flex min-w-0 items-center gap-1.5 text-xs font-medium',
        getExternalUrlValidationMessageClassName(
          props.status,
          props.hasLocalError,
        ),
        props.className,
      )}
    >
      {isBusy(props.status) && (
        <span
          aria-hidden="true"
          className="size-3 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent opacity-80"
        />
      )}
      <span className="truncate">{props.message}</span>
    </div>
  );
}
